<template>
	<div class="containerMain">
		<title-bar :topTitle="true"/>
		<div class="col inner" v-if="schoolSummary && teachers">
			<title-bar title="Docentes" :percentage="schoolSummary.schoolPercentage" percentageTitle="Promedio Colegio"/>
			<div class="finder">
				<b-form-input v-model="textFilterInputValue" placeholder="Escribe para filtrar"/>
			</div>
			<div class="col tableContainer" >
				<b-table v-if="teachersToRender.length > 0" class="category all" striped hover :items="teachersToRender" :fields="tableFields">
					<template slot="actions" slot-scope="item">
						<b-button size="lg" class="more" @click="goToRoute(item)">
							Ver más
						</b-button>
					</template>
				</b-table>
				<div v-if="teachersToRender.length == 0">No hay resultados.</div>
			</div>
		</div>
		<div class="col inner" v-else>
			<spinner :isMiniSpinner="true"/>
		</div>
	</div>
</template>

<script>
import helpers from '@/helpers';
import mediator from '@/mediator';
export default {
	timeoutFilter: null,
	filteredItems: null,
	mounted () {
		setTimeout(() => {
			mediator.showContent();
		}, 1000);
	},
	data () {
		return {
			tableFields: {
				name: {
					label: 'Nombre',
					sortable: true
				},
				average: {
					label: 'Promedio',
					sortable: true
				},
				category1: {
					label: 'Ambiente emocional',
					sortable: true
				},
				category2: {
					label: 'Proceso académico',
					sortable: true
				},
				category3: {
					label: 'Aprendizaje profundo',
					sortable: true
				},
				category4: {
					label: 'Aprendizaje experto',
					sortable: true
				},
				actions: {
					label: '',
					sortable: false
				}
			},
			textFilterInputValue: this.$router.currentRoute.query.textFilter || '',
			textFilterQuery: this.$router.currentRoute.query.textFilter || ''
		};
	},
	watch: {
		textFilterInputValue () {
			clearTimeout(this.timeoutFilter);

			if (this.textFilterInputValue === '' || this.textFilterInputValue.length < 3) {
				this.textFilterQuery = '';
				return;
			}

			this.timeoutFilter = setTimeout(() => {
				this.textFilterQuery = this.textFilterInputValue;
			}, 750);
		},
		perPage () {
			if (!this.perPage) this.perPage = 20;
		}
	},
	computed: {
		schoolSummary () {
			if (this.$store.state.school.summary) return this.$store.state.school.summary[0];
			else return this.$store.state.school.summary;
		},
		teachers () {
			if (!this.$store.state.teachers.summary) return null;
			return this.$store.state.teachers.summary.map((item) => {
				item.name = item.itemName;
				item.average = `${parseInt(item.itemPercentage)}%`;
				let category1 = item.coachingCategories.find((category) => {return category.id == 1;});
				let category2 = item.coachingCategories.find((category) => {return category.id == 2;});
				let category3 = item.coachingCategories.find((category) => {return category.id == 3;});
				let category4 = item.coachingCategories.find((category) => {return category.id == 4;});
				item.category1 = `${parseInt(category1.percentage)}%`;
				item.category2 = `${parseInt(category2.percentage)}%`;
				item.category3 = `${parseInt(category3.percentage)}%`;
				item.category4 = `${parseInt(category4.percentage)}%`;
				return item;
			});
		},
		teachersToRender () {
			if (!this.teachers) return [];
			if (!this.filtersApplied) return this.teachers;

			const filteredItems = this.teachers.filter((item) => {
				let match = true;
				if (this.textFilterQuery) match = helpers.textFilter.matchStringFromQuery(this.textFilterQuery, JSON.stringify(item));
				return match;
			});

			return filteredItems;
		},
		filtersApplied () {
			return (
				this.textFilterQuery !== ''
			);
		}
	},
	methods: {
		goToRoute (item) {
			this.$store.dispatch('setTeacherMenu', {
				uuid: item.item.itemId,
				fullName: item.item.itemName
			});
			this.$router.push('/coaching/teachers/summary/' + item.item.itemId);
		}
	}
};
</script>
<style lang="scss" scoped>
.tableContainer {
	margin: 1rem 0;
	padding: 0;
	flex-wrap: wrap;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/routes/teachers/List.vue